import React, { FunctionComponent } from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

const WrappedContent: FunctionComponent<any> = (props) => <Content {...props} />;

export default WrappedContent;
